import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { ABOUT_BACKGROUND_IMG } from 'configs/constants';

interface IProps {
  src: string;
}

export default makeStyles<Theme, IProps>(theme =>
  createStyles({
    root: {
      paddingTop: 30,
      paddingBottom: 30,
      color: theme.palette.common.white,
      [theme.breakpoints.up('md')]: {
        paddingTop: 95,
        paddingBottom: 105,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 30px center',
        backgroundSize: 'calc(100% - 875px) auto',
        minHeight: 620,
        '&.tele2Altel': {
          backgroundImage: `url(${ABOUT_BACKGROUND_IMG[0].url})`
        },
        '&.kcellActive': {
          backgroundImage: `url(${ABOUT_BACKGROUND_IMG[1].url})`
        },
        '&.beeline': {
          backgroundImage: `url(${ABOUT_BACKGROUND_IMG[2].url})`
        }
      }
    },
    content: {
      maxWidth: 576
    },
    list: {
      listStyle: 'disc',
      margin: '0 0 30px 15px',
      padding: 0,
      [theme.breakpoints.up('md')]: {
        marginBottom: 40
      }
    },
    item: {
      fontSize: 13,
      lineHeight: 1.5,
      [theme.breakpoints.up('md')]: {
        fontSize: 20
      }
    },
    button: {
      maxWidth: 328,
      width: '100%'
    }
  }), { name: 'About' }
);
